import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IJBPMasterDealerExtendedPartnersView } from 'clickNgo/models/crud/views'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getJbpExtendedPartnerDataCrud = (key?: string) =>
  CrudStore.get(
    CrudStoreItem.JBPMasterDealerExtendedPartners,
    key
  ) as Crud<IJBPMasterDealerExtendedPartnersView>
